import React from 'react';

import HeaderEnum from '../topLevelMenu/headerEnum';

import BaseMenu from './BaseMenu';

const AboutMenu: React.FC = () => {
  return (
    <BaseMenu
      headerEnum={HeaderEnum.About}
      className="about-menu"
      menuListClassName="about-menu-list"
    />
  );
};

export default AboutMenu;
